import {
  ODataHeader,
  ODataString,
  ODataEnum
} from "pbas-vue-components";
import { i18n } from '@/plugins/i18n';

function getPlansHeaders(options) {
  return [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      isIdentifier: true,
    }),
    new ODataHeader({
      type: new ODataString("BrokerId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false
    }),
    new ODataHeader({
      title: "globals.status",
      type: new ODataEnum("Status", {
        getString: (item) => {
          return i18n.t("enums." + item.Status);
        },
        getHtml: (item, type) => {
          const green = "#52BE80";
          const orange = "#EE4F09";
          const blue = "#0FA4EE";
          let color = green;
          if (item.Status === "Testing") {
            color = orange;
          } else if (item.Status === "Draft") {
            color = blue;
          }

          return (
            "<span style='background-color:" +
            color +
            ";padding:3px 6px;color:white;border-radius:3px;'>" +
            type.getString(item, type) +
            "</span>"
          );
        },
        dropdownItems: options.Enums.PlanStatus,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.name",
      type: new ODataString("Name"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true
    }),
    new ODataHeader({
      title: "headers.plans.identifier",
      type: new ODataString("UniqueIdentifier"),
      sortable: true,
      visible: true,
      searchable: true,
      version: 1
    }),
    new ODataHeader({
      type: new ODataString("PlanIdentityId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false
    }),
    new ODataHeader({
      type: new ODataString("IsValid"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false
    }),
    new ODataHeader({
      title: "globals.type",
      type: new ODataEnum("PlanType", {
        getString: (item) => {
          return i18n.t("enums." + item.PlanType);
        },
        dropdownItems: options.Enums.PlanType,
      }),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true
    }),
  ]
}

export default getPlansHeaders;